import React from 'react'
import type { PostSummary } from '../../types'
import { PostCard } from '../blog/PostCard'
import { LoadingSpinner } from '../ui/LoadingSpinner'

interface SearchResultsProps {
  results: PostSummary[]
  total: number
  query: string
  loading: boolean
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  total,
  query,
  loading,
}) => {
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
        <LoadingSpinner />
      </div>
    )
  }

  if (!query.trim()) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '48px 0',
          color: 'var(--text-secondary)',
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
          fontSize: '0.9rem',
        }}
      >
        <span style={{ color: 'var(--accent-green)' }}>&gt;_ </span>
        type something to search...
      </div>
    )
  }

  if (results.length === 0) {
    return (
      <div
        style={{
          padding: '48px 0',
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
        }}
      >
        <div style={{ color: 'var(--accent-amber)', marginBottom: '12px', fontSize: '0.85rem' }}>
          [ERROR] No results found
        </div>
        <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
          <span style={{ color: 'var(--accent-green)' }}>&gt;_ </span>
          No posts match &quot;{query}&quot;. Try different keywords.
        </div>
      </div>
    )
  }

  return (
    <>
      <style>{`
        .search-results-header {
          font-family: 'JetBrains Mono', 'Courier New', monospace;
          font-size: 0.82rem;
          color: var(--text-secondary);
          margin-bottom: 20px;
          padding: 8px 0;
          border-bottom: 1px solid var(--border-color);
        }
        .search-results-count {
          color: var(--accent-green);
        }
        .search-results-query {
          color: var(--accent-amber);
        }
        .search-results-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        @media (min-width: 768px) {
          .search-results-grid {
            grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
          }
        }
      `}</style>
      <div>
        <div className="search-results-header">
          <span className="search-results-count">{total}</span>
          {' '}result{total !== 1 ? 's' : ''} for{' '}
          <span className="search-results-query">&quot;{query}&quot;</span>
        </div>
        <div className="search-results-grid">
          {results.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </>
  )
}
